const HomeText = [
  `YOU TELL US WHAT YOU WANT TO BE,`,
  `Sign up now to be part of our product release coming this fall.`,
  `Find the right post-graduate courses to make yourself more employable.`,
  `Don’t let not knowing where to start, stop you from getting the skills you need. No more overwhelming research. No more comparison lists. No more Google searches. You’ve found your one-stop-shop for post-grad guidance and pricing.`,
  `Identify the best colleges and programs to upskill above other job-seekers and ramp up your earning power.`,
  `Search and sort programs based on location, grade requirements and cost.`,
  `See the certifications your industry demands—and the skills most commonly held by executives.`,
  `Learn how much money each degree will add to your salary.`,
  `Find the best places to go, and the right degrees to earn, to help you succeed.`,
  `We made this site because it didn’t exist when we needed it.`,
  `Now it does.`,
  `Join our mailing list, stay informed, and have first access to AcademME!`
]

export default HomeText



// WEBPACK FOOTER //
// src/text/home-text.js